import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import {
    useAppDispatch,
    useAppSelector,
} from "../../../../framework/customStore";
import {
    setPrimaryFilter,
    setSortOrder,
    PrimaryFilter,
} from "../../../../store/monitorViewFiltersSlice";

interface VehicleFiltersProps {
    countByPrimaryFilter: {
        all: number;
        working: number;
        notWorking: number;
    };
}

const VehicleFilters: React.FC<VehicleFiltersProps> = ({
    countByPrimaryFilter,
}) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const primaryFilter = useAppSelector(
        (state) => state.monitorViewFilters.primaryFilter
    );

    const filters: { label: string; value: PrimaryFilter; count: number }[] = [
        {
            label: t("monitorView.primaryFilter.all"),
            value: "all",
            count: countByPrimaryFilter.all,
        },
        {
            label: t("monitorView.primaryFilter.working"),
            value: "working",
            count: countByPrimaryFilter.working,
        },
        {
            label: t("monitorView.primaryFilter.notWorking"),
            value: "notWorking",
            count: countByPrimaryFilter.notWorking,
        },
    ];

    return (
        <Box sx={{ bgcolor: "#f5f5f5" }}>
            <Tabs
                value={primaryFilter}
                onChange={(_, newValue: PrimaryFilter) => {
                    dispatch(setPrimaryFilter(newValue));
                    dispatch(
                        setSortOrder(
                            newValue === "notWorking"
                                ? "registerNumber"
                                : "employeeName"
                        )
                    );
                }}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
            >
                {filters.map((filter) => (
                    <Tab
                        key={filter.value}
                        value={filter.value}
                        label={
                            <Box sx={{ textAlign: "center" }}>
                                <Typography variant="subtitle2">
                                    {filter.count}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{ fontSize: "0.7rem" }}
                                >
                                    {filter.label}
                                </Typography>
                            </Box>
                        }
                        sx={{ minWidth: 0, padding: "6px" }}
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default React.memo(VehicleFilters);
